import { render, staticRenderFns } from "./rjcpzx1.vue?vue&type=template&id=21da925f&scoped=true&"
import script from "./rjcpzx1.vue?vue&type=script&lang=js&"
export * from "./rjcpzx1.vue?vue&type=script&lang=js&"
import style0 from "./rjcpzx1.vue?vue&type=style&index=0&id=21da925f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da925f",
  null
  
)

export default component.exports